import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=23c074f0&scoped=true&"
import script from "./photoList.vue?vue&type=script&lang=js&"
export * from "./photoList.vue?vue&type=script&lang=js&"
import style0 from "./photoList.vue?vue&type=style&index=0&id=23c074f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c074f0",
  null
  
)

export default component.exports